import React, { Component } from "react";
import  { Link } from "react-router-dom";
class ProductsBusLevel extends Component {
  render() {
    return (
      <div>
        {/* <header class="productHeader">
          <h3 class="blue">Sensors, Logic Controls, Touch Panels & More</h3>
      </header> */}
        <header className="blue-bg title">
          <h1 className="white subh1">Products</h1>
          <Link to="/contact" className="text-right white"><span className="yellow">Get a Quote →</span></Link>
        </header>
        <div className="product-view">
          <div className="row">
            <div className="col sub-header mb-3">
              <h2>Bus Level &amp; <br />Networking Products</h2>
              <p className>We also carry products from the companies listed below and will be glad to assist
                you with any needs that you have.</p>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 column">
              <div className="card border">
                <div className="card-body">
                  <h3>Turck<span className="underline" /></h3>
                  <ul>
                    <li>PLCs</li>
                    <li>Network I/O</li>
                    <li>Connectivity products for automation and process control</li>
                  </ul>
                </div>
                <div className="card-footer">
                  <a className="read-more blue" href="https://www.seltrolshop.com/products?utf8=%E2%9C%93&search=turck" target="_blank">Shop Here</a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 column">
              <div className="card border">
                <div className="card-body">
                  <h3>Wago<span className="underline" /></h3>
                  <ul>
                    <li>PLCs</li>
                    <li>Open BUS connectivity</li>
                    <li>I/O products</li>
                    <li>Ethernet/IP</li>
                  </ul>
                </div>
                <div className="card-footer">
                  <a className="read-more blue" href="https://www.seltrolshop.com/products?utf8=%E2%9C%93&search=wago" target="_blank">Shop Here</a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 column">
              <div className="card border">
                <div className="card-body">
                  <h3>Sixnet by Red Lion<span className="underline" /></h3>
                  <ul>
                    <li>Industrial connectivity and industrial wireless</li>
                  </ul>
                </div>
                <div className="card-footer">
                  <a className="read-more blue" href="https://www.seltrolshop.com/products?utf8=%E2%9C%93&search=red+lion" target="_blank">Shop Here</a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 column">
              <div className="card border">
                <div className="card-body">
                  <h3>N-Tron<span className="underline" /></h3>
                  <ul>
                    <li>Highly reliable industrial network products for industrial Ethernet communications</li>
                  </ul>
                </div>
                <div className="card-footer">
                  <a className="read-more blue" href="http://www.redlion.net/n-tron" target="_blank">View Site</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
};
export default ProductsBusLevel;
